export default __webpack_public_path__ + "static/media/operating-performance-1.190350e1.png";